// extracted by mini-css-extract-plugin
export default {"changeNote":"changeNote---NX1Cf"};